<template>
  <div class="microphone-webrtc">
    <BaseFormDevice
      @un-selected="unSelectedDevice"
      @change-selected="changeSelectedDevice"
      @change-reload="changeReloadDevice"
      @selectedAll="selectedAll"
      @dataSearch="dataSearch"
      :loadData="reloadDataDevice"
    />

    <CButton
      class="mb-3"
      color="primary"
      :disabled="actionData.model.listDeviceSelectedCode.length === 0"
      @click="showMicPanel"
    >
      <i class="fa fa-microphone" />&nbsp;Thực hiện phát thanh
    </CButton>

    <CModal
      v-if="isShowMicrophonePanel"
      :show.sync="isShowMicrophonePanel"
      size="lg"
      :closeOnBackdrop="false"
      class="mic-modal"
    >
      <template v-slot:header>
        <div class="mic-modal-header">
          <div class="mic-modal-header-icon">
            <i class="fa fa-microphone" />
          </div>
          <div class="mic-modal-header-text">
            <h5 class="mic-modal-title">Phát thanh trực tiếp</h5>
            <span class="mic-modal-subtitle">Cấu hình và điều khiển phát thanh</span>
          </div>
          <button type="button" class="mic-modal-close" aria-label="Đóng" @click="closeMicPanel">
            <i class="fa fa-times" />
          </button>
        </div>
      </template>
      <div class="mic-modal-body">
        <div class="mic-page mic-page--in-modal">
          <div class="mic-card">
          <div class="mic-card-body">
          <div class="mic-field mic-field-full">
            <div class="mic-label-row">
              <label class="mic-label-mic">
                <i class="fa fa-microphone" /> Danh sách microphone
                <span v-if="isPublishing" class="mic-hint-inline">— có thể đổi khi đang phát</span>
              </label>
              <div class="mic-label-actions">
                <CButton size="sm" color="secondary" class="mic-btn-refresh" @click="loadDevices">
                  <i class="fa fa-refresh" />&nbsp;Làm mới
                </CButton>
              </div>
            </div>
            <div class="mic-select-wrap mic-select-wrap--base">
              <BaseSelect :options="micSelect.options" :data="micSelect.data" ref="micSelect" />
            </div>
            <p class="mic-list-hint">
              {{ microphoneOptions.length > 1 ? `Có ${microphoneOptions.length - 1} microphone. Chọn một rồi bấm Bắt đầu phát hoặc đổi khi đang phát.` : 'Bấm "Làm mới danh sách" hoặc "Bắt đầu phát" để tải microphone.' }}
            </p>
          </div>

          <div class="mic-field mic-field-full">
            <label>Âm lượng <span class="mic-volume-value">{{ volume }}%</span></label>
            <input
              v-model.number="volume"
              type="range"
              min="0"
              max="100"
              class="mic-slider"
            >
          </div>

          <div v-if="statusMessage || isPublishing || isConnecting" class="mic-status" :class="statusClass">
            <div class="mic-status-header">
              <template v-if="statusMessage">
                <i v-if="statusClass === 'text-success'" class="fa fa-check-circle" />
                <i v-else-if="statusClass === 'text-danger'" class="fa fa-exclamation-circle" />
                <i v-else class="fa fa-info-circle" />
                <span>{{ statusMessage }}</span>
              </template>
              <span v-if="isPublishing" class="mic-badge mic-badge-live mic-badge-live--inline">
                <i class="fa fa-circle" /> LIVE
              </span>
            </div>
            <div v-if="isPublishing" class="mic-vu">
              <div class="mic-vu-track">
                <div class="mic-vu-fill" :style="{ width: volumeLevel + '%' }" />
              </div>
              <span class="mic-vu-label">Mức âm thanh</span>
              <button
                type="button"
                class="mic-btn-mute mic-btn-mute--compact"
                :class="{ 'mic-btn-mute--active': isMuted }"
                :title="isMuted ? 'Bật mic' : 'Tắt mic'"
                @click="toggleMute"
              >
                <i :class="isMuted ? 'fa fa-microphone-slash' : 'fa fa-microphone'" />
                <span>{{ isMuted ? 'Bật mic' : 'Tắt mic' }}</span>
              </button>
            </div>
          </div>

          <div class="mic-actions">
            <button
              type="button"
              class="mic-btn mic-btn-start"
              :disabled="isPublishing || isConnecting"
              @click="startPublish"
            >
              <i class="fa fa-microphone" />
              {{ isPublishing ? 'Đang phát...' : (isConnecting ? 'Đang kết nối...' : 'Bắt đầu phát') }}
            </button>
            <button
              type="button"
              class="mic-btn mic-btn-stop"
              :disabled="!isPublishing"
              @click="stopPublish"
            >
              <i class="fa fa-stop" /> Dừng phát
            </button>
          </div>

          <div v-if="recordedBlobUrl" class="mic-playback">
            <div class="mic-playback-header">
              <span class="mic-playback-title"><i class="fa fa-headphones" /> Nghe thử bản ghi</span>
            </div>
            <audio
              ref="playbackAudio"
              :src="recordedBlobUrl"
              class="mic-playback-audio"
              preload="auto"
              @loadedmetadata="onPlaybackLoaded"
              @durationchange="onPlaybackLoaded"
              @loadeddata="onPlaybackLoaded"
              @timeupdate="onPlaybackTimeUpdate"
              @ended="onPlaybackEnded"
            />
            <div class="mic-playback-controls">
              <button type="button" class="mic-playback-btn" @click="togglePlayback" :title="isPlaybackPlaying ? 'Tạm dừng' : 'Phát'">
                <i :class="isPlaybackPlaying ? 'fa fa-pause' : 'fa fa-play'" />
              </button>
              <div class="mic-playback-timeline">
                <input
                  type="range"
                  class="mic-playback-range"
                  min="0"
                  :max="playbackDurationSafe"
                  step="0.1"
                  :value="playbackCurrent"
                  @input="onSeekPlayback"
                >
                <div class="mic-playback-time">
                  <span class="mic-playback-time-current">{{ formatTime(playbackCurrent) }}</span>
                  <span class="mic-playback-time-sep">/</span>
                  <span class="mic-playback-time-total">{{ formatTime(playbackDuration) }}</span>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      </div>
      <template v-slot:footer>
        <div class="mic-modal-footer">
          <button type="button" class="mic-modal-btn-close" @click="closeMicPanel">
            <i class="fa fa-times" /> Đóng
          </button>
        </div>
      </template>
    </CModal>

    <CModal
      :title="generateModalConfirm(confirmOverrideScheduleEmergency.type)"
      :show.sync="confirmOverrideScheduleEmergency.isShowModal"
      :closeOnBackdrop="false"
      size="lg"
      class="mic-modal mic-modal-confirm"
    >
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          <template v-if="confirmOverrideScheduleEmergency.type === 0">
            Hiện tại đang phát bản tin khẩn cấp được gửi từ
            <span style="font-weight: 700;">
              {{ confirmOverrideScheduleEmergency.locationName }}
            </span>
            bắt đầu từ
            <b>{{ confirmOverrideScheduleEmergency.startTime }}</b>
            và kết thúc lúc
            <b>{{ confirmOverrideScheduleEmergency.endTime }}</b>
            trên các thiết bị:
            <br />
            <span v-for="i of confirmOverrideScheduleEmergency.devices" :key="i">
              {{ i + ', ' }}
            </span>
            <span style="color: #ff0303; font-weight: bold;">
              (Chèn phát trực tiếp sẽ làm gián đoạn bản tin phát thanh khẩn cấp đang được đặt, vui lòng cân nhắc trước
              khi nhấn "Xác nhận")
            </span>
            <div>Bạn chắc chắn muốn chèn lịch khẩn cấp trên các thiết bị này?</div>
            <div>Nhấn <span class="text-modal-confirm">Xác nhận</span> để thực hiện.</div>
          </template>

          <template v-else-if="confirmOverrideScheduleEmergency.type === 1">
            Hiện tại đang phát trực tiếp trên các thiết bị:
            <br />
            <span v-for="i of confirmOverrideScheduleEmergency.devices" :key="i">
              {{ i + ', ' }}
            </span>
            <span style="font-weight: bold;">
              (Việc chèn sẽ làm địa bàn đang phát trực tiếp bị gián đoạn, vui lòng cân nhắc trước khi nhấn "Xác nhận")
            </span>
            <div>Bạn chắc chắn muốn chèn sóng phát trực tiếp trên các thiết bị này?</div>
            <div>Nhấn <span class="text-modal-confirm">Xác nhận</span> để thực hiện.</div>
          </template>

          <template v-else-if="confirmOverrideScheduleEmergency.type === 2">
            Hiện tại đang có Cán bộ phát trực tiếp trên các thiết bị:
            <br />
            <span v-for="i of confirmOverrideScheduleEmergency.devices" :key="i">
              {{ i + ', ' }}
            </span>
            <div>Xin vui lòng thực hiện lại sau ít phút.</div>
          </template>

          <template v-else-if="confirmOverrideScheduleEmergency.type === 3">
            Nguyên nhân: Người dùng cấp trên đã chiếm quyền ưu tiên luồng phát trực tiếp theo phân cấp, phân quyền. Vui
            lòng thử lại sau!
          </template>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="closeOverrideScheduleEmergencyPlaying">
          <i class="fa fa-times" /> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitOverrideScheduleEmergencyPlaying">
          <i class="fa fa-check" /> Xác nhận
        </button>
      </template>
    </CModal>

    <BaseFormLoading :loading="loading.value" />
  </div>
</template>

<script>
import { ACCESS_TOKEN_EXPIRED, ACCESS_TOKEN_NAME } from '@/constant';
import { startBackgroundLivestreamRecordUpload } from '@/utils/livestreamRecordUploadManager';
import BaseFormDevice from '@/views/base/BaseFormDevice';
import BaseFormLoading from '@/views/base/BaseFormLoading';
import BaseSelect from '@/views/base/BaseSelect2';

/** Sau khi WHIP connected, RTSP trên MediaMTX thường cần ~2–3s mới play ổn; gửi init sớm khiến thiết bị mở link trước khi có dữ liệu → mất vài giây đầu. */
const PLAYBACK_LINK_READY_DELAY_MS = 2800;

function randomString() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

/** Username:password = random (Basic auth). Token từ localStorage gửi qua header Bearer. Query node lấy từ conf.node (mặc định tna). */
function getMediaMtxAuth() {
  const token = localStorage.getItem(ACCESS_TOKEN_NAME);
  return {
    user: randomString(),
    pass: randomString(),
    token: token || undefined
  };
}

/**
 * WHIP publisher chỉ audio - tương thích MediaMtx
 * URL: http(s)://host:port/streamName/whip
 */
function createWhipPublisher(conf) {
  let state = 'running';
  let pc = null;
  let offerData = null;
  let sessionUrl = null;
  let queuedCandidates = [];
  let restartTimeout = null;
  const retryPause = 2000;

  function unquoteCredential(v) {
    return JSON.parse(`"${v}"`);
  }

  function linkToIceServers(links) {
    if (!links) return [];
    return links.split(', ').map((link) => {
      const m = link.match(/^<(.+?)>; rel="ice-server"(; username="(.*?)"; credential="(.*?)"; credential-type="password")?/i);
      const ret = { urls: [m[1]] };
      if (m[3] !== undefined) {
        ret.username = unquoteCredential(m[3]);
        ret.credential = unquoteCredential(m[4]);
        ret.credentialType = 'password';
      }
      return ret;
    });
  }

  function parseOffer(offer) {
    const ret = { iceUfrag: '', icePwd: '', medias: [] };
    for (const line of offer.split('\r\n')) {
      if (line.startsWith('m=')) ret.medias.push(line.slice(2));
      else if (ret.iceUfrag === '' && line.startsWith('a=ice-ufrag:')) ret.iceUfrag = line.slice(12);
      else if (ret.icePwd === '' && line.startsWith('a=ice-pwd:')) ret.icePwd = line.slice(10);
    }
    return ret;
  }

  /**
   * Chỉnh SDP offer: bitrate thấp, low-latency vừa phải, bật FEC để giảm RTP packet lost.
   * - minptime=5: gom frame nhỏ, cân bằng trễ / số gói (ít gói hơn minptime=0).
   * - useinbandfec=1: bật FEC để che mất gói, hạn chế log "RTP packet lost" trên MediaMtx.
   */
  function setAudioBitrateInOffer(sdp, bitrateKbps) {
    const bps = Math.max(6000, (bitrateKbps || 16) * 1000);
    const lines = sdp.split('\r\n');
    let opusPayload = '';
    for (const line of lines) {
      if (line.startsWith('a=rtpmap:') && line.toLowerCase().includes('opus/')) {
        opusPayload = line.slice(9).split(' ')[0];
        break;
      }
    }
    if (!opusPayload) return sdp;
    const out = [];
    for (const line of lines) {
      if (line.startsWith('a=fmtp:' + opusPayload + ' ') || line.startsWith('a=fmtp:' + opusPayload + '\t')) {
        const rest = line.slice(8 + opusPayload.length).trim();
        const params = new Map();
        rest.split(';').forEach((p) => {
          const eq = p.indexOf('=');
          if (eq > 0) params.set(p.slice(0, eq).trim(), p.slice(eq + 1).trim());
        });
        params.set('maxaveragebitrate', String(bps));
        params.set('minptime', '5');
        params.set('useinbandfec', '1');
        out.push('a=fmtp:' + opusPayload + ' ' + [...params.entries()].map(([k, v]) => k + '=' + v).join(';'));
      } else {
        out.push(line);
      }
    }
    return out.join('\r\n');
  }

  function generateSdpFragment(od, candidates) {
    const candidatesByMedia = {};
    for (const c of candidates) {
      const mid = c.sdpMLineIndex;
      if (!candidatesByMedia[mid]) candidatesByMedia[mid] = [];
      candidatesByMedia[mid].push(c);
    }
    let frag = 'a=ice-ufrag:' + od.iceUfrag + '\r\na=ice-pwd:' + od.icePwd + '\r\n';
    let mid = 0;
    for (const media of od.medias) {
      if (candidatesByMedia[mid]) {
        frag += 'm=' + media + '\r\na=mid:' + mid + '\r\n';
        for (const c of candidatesByMedia[mid]) frag += 'a=' + c.candidate + '\r\n';
      }
      mid++;
    }
    return frag;
  }

  function authHeader() {
    const headers = {};
    if (conf.token) headers.Authorization = 'Bearer ' + conf.token;
    else if (conf.user) headers.Authorization = 'Basic ' + btoa(conf.user + ':' + (conf.pass || ''));
    return headers;
  }

  function requestICEServers() {
    return fetch(conf.url, { method: 'OPTIONS', headers: authHeader() })
      .then((res) => linkToIceServers(res.headers.get('Link')));
  }

  function setupPeerConnection(iceServers) {
    if (state !== 'running') throw new Error('closed');
    pc = new RTCPeerConnection({
      iceServers: iceServers.length ? iceServers : [{ urls: 'stun:stun.l.google.com:19302' }],
      sdpSemantics: 'unified-plan'
    });
    pc.onicecandidate = (evt) => {
      if (state !== 'running') return;
      if (evt.candidate) {
        if (sessionUrl) sendLocalCandidates([evt.candidate]);
        else queuedCandidates.push(evt.candidate);
      }
    };
    pc.onconnectionstatechange = () => {
      if (state !== 'running') return;
      if (pc.connectionState === 'failed' || pc.connectionState === 'closed') {
        conf.onError('Kết nối đã đóng');
      } else if (pc.connectionState === 'connected') {
        if (conf.onConnected) conf.onConnected();
      }
    };
    conf.stream.getTracks().forEach((track) => pc.addTrack(track, conf.stream));
    const audioBitrateKbps = conf.audioBitrateKbps != null ? conf.audioBitrateKbps : 16;
    return pc.createOffer().then((offer) => {
      const modifiedSdp = setAudioBitrateInOffer(offer.sdp, audioBitrateKbps);
      const modifiedOffer = { type: 'offer', sdp: modifiedSdp };
      offerData = parseOffer(modifiedSdp);
      return pc.setLocalDescription(modifiedOffer).then(() => modifiedSdp);
    });
  }

  function sendOffer(offer) {
    if (state !== 'running') throw new Error('closed');
    return fetch(conf.url, {
      method: 'POST',
      headers: { ...authHeader(), 'Content-Type': 'application/sdp' },
      body: offer
    }).then((res) => {
      if (res.status === 201) {
        const u = new URL(res.headers.get('Location'), conf.url);
        if (conf.node && !u.searchParams.has('node')) u.searchParams.set('node', conf.node);
        sessionUrl = u.toString();
        return res.text();
      }
      if (res.status === 400) return res.json().then((e) => { throw new Error(e.error || 'Bad request'); });
      throw new Error('Máy chủ trả về: ' + res.status);
    });
  }

  function setAnswer(answer) {
    if (state !== 'running') return Promise.resolve();
    return pc.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: answer })).then(() => {
      if (state === 'running' && queuedCandidates.length) {
        sendLocalCandidates(queuedCandidates);
        queuedCandidates = [];
      }
    });
  }

  function sendLocalCandidates(candidates) {
    fetch(sessionUrl, {
      method: 'PATCH',
      headers: {
        ...authHeader(),
        'Content-Type': 'application/trickle-ice-sdpfrag',
        'If-Match': '*'
      },
      body: generateSdpFragment(offerData, candidates)
    }).then((res) => {
      if (res.status !== 204 && res.status !== 200) throw new Error('PATCH candidates: ' + res.status);
    }).catch((err) => conf.onError(err.toString()));
  }

  function deleteSession() {
    if (!sessionUrl) return Promise.resolve();
    const url = sessionUrl;
    sessionUrl = null;
    return fetch(url, { method: 'DELETE', headers: authHeader() }).catch(() => {});
  }

  function handleError(err) {
    if (state !== 'running') return;
    offerData = null;
    deleteSession().finally(() => {
      if (pc) { pc.close(); pc = null; }
      queuedCandidates = [];
      state = 'restarting';
      restartTimeout = setTimeout(() => {
        restartTimeout = null;
        state = 'running';
        getIceServers()
          .then(setupPeerConnection)
          .then(sendOffer)
          .then(setAnswer)
          .catch((e) => conf.onError(e.toString()));
      }, retryPause);
    });
    conf.onError(err + ' – sẽ thử lại sau vài giây.');
  }

  function getIceServers() {
    const custom = conf.iceServers;
    if (custom && Array.isArray(custom) && custom.length > 0) {
      return Promise.resolve(custom);
    }
    return requestICEServers();
  }

  function start() {
    getIceServers()
      .then(setupPeerConnection)
      .then(sendOffer)
      .then(setAnswer)
      .catch(handleError);
  }

  start();

  /** Chỉ đổi track input (microphone), không reconnect livestream. */
  function replaceTrack(newTrack) {
    if (state !== 'running' || !pc) return Promise.reject(new Error('not connected'));
    const senders = pc.getSenders();
    const audioSender = senders.find((s) => s.track && s.track.kind === 'audio') || senders[0];
    if (!audioSender) return Promise.reject(new Error('no sender'));
    return audioSender.replaceTrack(newTrack);
  }

  return {
    close() {
      state = 'closed';
      if (restartTimeout) clearTimeout(restartTimeout);
      deleteSession().finally(() => {
        if (pc) pc.close();
      });
    },
    replaceTrack
  };
}

export default {
  name: 'MicrophonePushRTMP',
  components: {
    BaseFormDevice,
    BaseFormLoading,
    BaseSelect
  },
  data() {
    return {
      reloadDataDevice: false,
      actionData: {
        model: {
          selectedAll: false,
          deviceSelectedId: null,
          deviceSelectedName: null,
          status: null,
          listDeviceSelectedCode: [],
          type: null,
          dataSearch: {},
          deviceIgnoreIds: []
        }
      },
      confirmOverrideScheduleEmergency: {
        isShowModal: false,
        playDate: '',
        startTime: '',
        endTime: '',
        devices: '',
        scheduleId: '',
        type: '',
        level: '',
        scheduleIdOverride: ''
      },
      isClickLivestream: false,
      isShowMicrophonePanel: false,
      loading: { value: false },
      serverUrl: '',
      streamName: 'mic',
      // Thời điểm startTime (từ start_success) để client phát đồng bộ đúng lịch.
      playbackStartTime: '',
      whipNode: '',
      /** ICE servers (STUN/TURN) từ start_success.peerConnections, dùng cho RTCPeerConnection */
      peerConnectionConfig: [],
      selectedDeviceId: '',
      microphoneOptions: [],
      micSelect: {
        options: {
          label: '',
          filter: false,
          selectAllText: null,
          keyField: 'value',
          valueField: 'label',
          disabled: false,
        },
        data: {
          name: 'micSelect',
          items: [],
          model: ''
        }
      },
      switchingMic: false,
      volume: 100,
      isPublishing: false,
      isConnecting: false,
      statusMessage: '',
      statusClass: 'text-info',
      localStream: null,
      publishStream: null,
      whipPublisher: null,
      volumeLevel: 0,
      analyser: null,
      animationId: null,
      audioCtx: null,
      gainNode: null,
      currentPublishDeviceId: null,
      isMuted: false,
      mediaRecorder: null,
      recordedChunks: [],
      recordedBlobUrl: null,
      playbackDuration: 0,
      playbackCurrent: 0,
      isPlaybackPlaying: false,
      /** Timer trì hoãn gửi init/playback xuống thiết bị sau onConnected */
      playbackLinkDelayTimer: null,
      /** Timer heartbeat để backend auto-end được khi client treo/kill bất thường */
      livestreamHeartbeatTimer: null
    };
  },
  watch: {
    volume(v) {
      if (this.gainNode) this.gainNode.gain.value = this.isMuted ? 0 : v / 100;
    },
    'micSelect.data.model'(newVal) {
      const id = (newVal !== undefined && newVal !== null) ? String(newVal) : '';
      if (id !== this.selectedDeviceId) this.selectedDeviceId = id;
    },
    selectedDeviceId(newId) {
      if (this.isPublishing && newId && newId !== this.currentPublishDeviceId) {
        this.switchMicrophone(newId);
      }
      if (this.micSelect.data.model !== newId) this.micSelect.data.model = newId;
    },
    isShowMicrophonePanel(show) {
      if (!show) this.stopPublish();
    },
    recordedBlobUrl(url) {
      if (!url) return;
      this.playbackCurrent = 0;
      this.isPlaybackPlaying = false;
      this.$nextTick(() => {
        const audio = this.$refs.playbackAudio;
        if (audio) {
          audio.load();
        }
      });
    },
    '$store.state.liveStreamMessage'(value) {
      if (!value) return;
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') {
        return;
      }
      // Phần confirm trùng lịch / bị chèn sóng
      if (value.returnCode === 0 && value.data) {
        if (!this.isClickLivestream) return;
        if (value.data.type === 0) {
          this.confirmOverrideScheduleEmergency = {
            isShowModal: true,
            devices: value.data.devices,
            locationName: value.data.locationName,
            startTime: value.data.startTime,
            endTime: value.data.endTime,
            scheduleId: value.data.id,
            type: 0
          };
        } else if (value.data.type === 1) {
          this.confirmOverrideScheduleEmergency = {
            isShowModal: true,
            devices: value.data.devices,
            level: value.data.level,
            scheduleIdOverride: value.data.scheduleId,
            type: 1
          };
        } else if (value.data.type === 2) {
          this.confirmOverrideScheduleEmergency = {
            isShowModal: true,
            devices: value.data.devices,
            level: value.data.level,
            type: 2
          };
        } else if (value.data.type === 3) {
          this.stopPublish();
          this.confirmOverrideScheduleEmergency = {
            isShowModal: true,
            level: value.data.level,
            type: 3
          };
        }
      } else if (value.returnCode === 1 && value.data) {
        // Tạo lịch stream thành công (giống LiveStream.vue)
        const data = value.data;
        switch (data.type) {
          case 'check_emergency_success':
            // Check xong phía socket OK thì bắt đầu phát
            this.startPublishCore();
            break;
          case 'start_success':
            this.handleStartLiveStreamSuccess(data);
            break;
          default:
            break;
        }
      }
    }
  },
  computed: {
    hasMediaMtxAuth() {
      return !!localStorage.getItem(ACCESS_TOKEN_NAME);
    },
    playbackDurationSafe() {
      const d = Number(this.playbackDuration);
      const base = Number.isFinite(d) && d > 0 ? d : 0;
      const cur = Number(this.playbackCurrent);
      return Number.isFinite(cur) && cur > base ? cur : base;
    },
    whipUrl() {
      const base = (this.serverUrl || '').trim();
      if (!base) return '';
      const hasProtocol = /^https?:\/\//i.test(base);
      const host = hasProtocol ? base : 'http://' + base;
      const path = (this.streamName || 'mic').replace(/^\/+|\/+$/g, '');
      if (!path) return '';
      let url = `${host.replace(/\/+$/, '')}/${path}/whip`;
      const node = (this.whipNode || '').trim();
      if (node) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'node=' + encodeURIComponent(node);
      return url;
    }
  },
  mounted() {
    this.loadDevices();
    this._onBeforeUnloadLivestream = (e) => this.handleBeforeUnloadLivestream(e);
    this._onPageHideLivestream = (e) => this.handlePageHideLivestream(e);
    window.addEventListener('beforeunload', this._onBeforeUnloadLivestream);
    window.addEventListener('pagehide', this._onPageHideLivestream);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this._onBeforeUnloadLivestream);
    window.removeEventListener('pagehide', this._onPageHideLivestream);
    this.stopLivestreamHeartbeat();
    this.stopPublish();
  },
  methods: {
    /**
     * Chỉ hiển thị hộp thoại mặc định của trình duyệt (F5 / đóng tab) — không dừng phát ở đây
     * (nếu gọi stopPublish trong beforeunload thì sẽ dừng trước khi người dùng bấm Hủy).
     */
    handleBeforeUnloadLivestream(e) {
      if (this.isPublishing || (this.mediaRecorder && this.mediaRecorder.state === 'recording')) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
    /**
     * Sau khi người dùng xác nhận rời trang: dừng phát giống bấm dừng → stopRecording → onstop → upload chunk.
     * (Không gọi trong beforeunload — chỉ khi thật sự unload, tránh bfcache khi persisted.)
     */
    handlePageHideLivestream(e) {
      if (e.persisted) return;
      if (!this.isPublishing && !(this.mediaRecorder && this.mediaRecorder.state !== 'inactive')) {
        return;
      }
      this.stopPublish();
    },
    startLivestreamHeartbeat() {
      this.stopLivestreamHeartbeat();
      this.sendLivestreamHeartbeat();
      this.livestreamHeartbeatTimer = setInterval(() => {
        this.sendLivestreamHeartbeat();
      }, 30000);
    },
    stopLivestreamHeartbeat() {
      if (this.livestreamHeartbeatTimer) {
        clearInterval(this.livestreamHeartbeatTimer);
        this.livestreamHeartbeatTimer = null;
      }
    },
    sendLivestreamHeartbeat() {
      if (!this.streamName || typeof this.$sendMessageSocket !== 'function') return;
      const scheduleId = Number(this.streamName);
      if (!Number.isFinite(scheduleId) || scheduleId <= 0) return;
      try {
        this.$sendMessageSocket('/app/livestream', JSON.stringify({
          mode: 1,
          type: 'heartbeat',
          scheduleId
        }));
      } catch (_) {}
    },
    /** Chuẩn hóa peerConnections từ backend thành mảng RTCIceServer (urls, username?, credential?). */
    normalizePeerConnections(peerConnections) {
      if (!peerConnections || !Array.isArray(peerConnections)) return [];
      return peerConnections
        .map((item) => {
          if (item == null) return null;
          if (typeof item === 'string') {
            return { urls: item.trim() ? item : null };
          }
          const urls = item.urls != null ? item.urls : item.url;
          if (urls == null) return null;
          const server = {
            urls: typeof urls === 'string' ? urls : urls
          };
          if (item.username != null) server.username = item.username;
          if (item.credential != null) server.credential = item.credential;
          return server;
        })
        .filter((s) => s && s.urls);
    },
    handleStartLiveStreamSuccess(signal) {
      if (signal && signal.scheduleId != null) {
        // streamName chính là scheduleId do backend tạo
        this.streamName = String(signal.scheduleId);
        this.startLivestreamHeartbeat();
        // Lưu startTime để gửi xuống thiết bị khi bắt đầu playback
        this.playbackStartTime = signal.startTime != null ? String(signal.startTime) : '';
        // Server WHIP/stream lấy từ response, thay cho MEDIAMTX_DEFAULT
        if (signal.serverUrl != null && signal.serverUrl !== '') {
          this.serverUrl = String(signal.serverUrl).trim();
        }
        // Cấu hình ICE (STUN/TURN) cho RTCPeerConnection
        this.peerConnectionConfig = this.normalizePeerConnections(signal.peerConnections);
        // Sau khi backend xác nhận start_success thì mới bắt đầu đẩy WHIP
        this.startWhipPublish();
      }
    },
    getRealIp() {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: 'https://api.ipify.org?format=json',
          dataType: 'json',
          timeout: 3000,
          success(data) {
            resolve(data.ip);
          },
          error(err) {
            reject(err);
          }
        });
      });
    },
    generateModalConfirm(type) {
      if (type === 0) {
        return 'Xác nhận chèn lịch khẩn cấp';
      } if (type === 1) {
        return 'Xác nhận chèn sóng phát trực tiếp';
      } if (type === 2) {
        return 'Trùng lịch phát trực tiếp';
      } if (type === 3) {
        return 'Phát trực tiếp bị gián đoạn';
      }
      return '';
    },
    closeOverrideScheduleEmergencyPlaying() {
      this.confirmOverrideScheduleEmergency.isShowModal = false;
      this.isClickLivestream = false;
    },
    submitOverrideScheduleEmergencyPlaying() {
      if (this.confirmOverrideScheduleEmergency.type === 0 || this.confirmOverrideScheduleEmergency.type === 1) {
        this.confirmOverrideScheduleEmergency.isShowModal = false;
        this.isClickLivestream = false;
        this.startPublishCore();
      } else {
        this.closeOverrideScheduleEmergencyPlaying();
      }
    },
    checkExitsScheduleEmergencyPlaying() {
      return new Promise((resolve, reject) => {
        const that = this;
        that.$helper.loadDataSource({
          loading: that.loading,
          url: '/schedule/check_schedule_emergency_livestream_api',
          dataSubmit() {
            return {
              deviceIds: that.actionData.model.listDeviceSelectedCode,
              searchDeviceModel: that.actionData.model.dataSearch,
              selectedAll: that.actionData.model.selectedAll,
              deviceIgnoreIds: that.actionData.model.deviceIgnoreIds
            };
          },
          successCallback(response) {
            resolve(response);
          },
          errorCallback(error) {
            reject(error);
          }
        });
      });
    },
    changeSelectedDevice(value) {
      this.actionData.model.listDeviceSelectedCode = value;
    },
    unSelectedDevice(value) {
      this.actionData.model.deviceIgnoreIds = value;
    },
    selectedAll(value) {
      this.actionData.model.selectedAll = value;
    },
    dataSearch(value) {
      this.actionData.model.dataSearch = value;
    },
    changeReloadDevice(value) {
      this.reloadDataDevice = value;
    },
    submitRefreshToken() {
      const expiredToken = localStorage.getItem(ACCESS_TOKEN_EXPIRED);
      const timeExpired = new Date(expiredToken * 1).getTime();
      const now = new Date().getTime();
      const minusExpired = Math.round((timeExpired - now) / 60000);
      // const minusExpired = 31;
      if (minusExpired <= 30) {
        this.$helper.loadDataSource({
          loading: this.loading,
          url: '/users/refresh',
          isRequestBearerToken: false,
          options: { withCredentials: true },
          isJsonContentType: false,
          successCallback: (response) => {
            if (this.$helper.validResponse(this.$router, response.data)) {
              localStorage.setItem(ACCESS_TOKEN_EXPIRED, response.data.data.expires_in);
              localStorage.setItem(ACCESS_TOKEN_NAME, response.data.data.access_token);
              // Đang publish thì giữ socket hiện tại để không làm rớt luồng.
              const isLiveSessionActive = this.isPublishing || this.isConnecting;
              if (!isLiveSessionActive) {
                this.$disConnectSocket();
                this.$store.commit('set', ['reconnectSocket', true]);
              }
              this.isShowMicrophonePanel = true;
            } else {
              this.$helper.setupErrorModel(response.data.data, this.$data);
            }
          },
          errorCallback: (error) => {
            this.$helper.handleError(this.$router, error);
          }
        });
      } else {
        this.isShowMicrophonePanel = true;
      }
    },
    showMicPanel() {
      this.submitRefreshToken();
    },
    closeMicPanel() {
      this.clearRecordedPlayback();
      this.isShowMicrophonePanel = false;
    },
    /** Chuyển lỗi từ server/WebRTC thành thông báo chung, dễ hiểu. */
    normalizeStatusError(err) {
      const name = (err && err.name) ? String(err.name).toLowerCase() : '';
      const msg = (err && (err.message || err.toString && err.toString())) || '';
      const s = msg.toLowerCase();
      if (name === 'notfounderror' || s.includes('no device') || s.includes('không tìm thấy thiết bị')) {
        return 'Không tìm thấy microphone nào. Vui lòng kết nối microphone và thử lại.';
      }
      if (s.includes('authentication') || s.includes('401') || s.includes('code 400') || s.includes('xác thực')) return 'Xác thực thất bại. Kiểm tra đăng nhập hoặc quyền truy cập.';
      if (s.includes('404') || s.includes('not found')) return 'Không tìm thấy luồng hoặc đường dẫn.';
      if (s.includes('closed') || s.includes('failed') || s.includes('gián đoạn')) return 'Kết nối bị gián đoạn. Bạn có thể thử phát lại.';
      if (name === 'notallowederror' || s.includes('notallowed') || s.includes('permission')) return 'Không có quyền truy cập microphone.';
      return 'Đã xảy ra lỗi. Vui lòng thử lại.';
    },
    loadDevices() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        return;
      }
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          const mics = devices.filter((d) => d.kind === 'audioinput');
          const hasReadableLabel = mics.some((d) => d.label && d.label.trim());

          // Chưa có quyền microphone hoặc không có thiết bị: chỉ hiển thị placeholder hướng dẫn
          if (!mics.length || !hasReadableLabel) {
            this.selectedDeviceId = '';
            this.micSelect.data.items = this.microphoneOptions;
            this.micSelect.data.model = '';
            return;
          }

          this.microphoneOptions = [
            { value: '', label: 'Mặc định (trình duyệt chọn)' },
            ...mics.map((d, i) => ({
              value: d.deviceId,
              label: (d.label && d.label.trim()) ? d.label : 'Microphone ' + (i + 1)
            }))
          ];

          setTimeout(() => {
            const firstId = mics[0] && mics[0].deviceId ? mics[0].deviceId : '';
            const currentId =
              this.selectedDeviceId !== undefined && this.selectedDeviceId !== null
                ? String(this.selectedDeviceId)
                : '';
            // Đã chọn mic cụ thể và vẫn còn trong danh sách → giữ nguyên.
            // Chưa chọn (rỗng) hoặc ID cũ không còn → chọn mic đầu tiên (sau khi cấp quyền, v.v.).
            const hasValidSelection =
              currentId !== '' && mics.some((d) => d.deviceId === currentId);
            if (!hasValidSelection && firstId) {
              this.selectedDeviceId = firstId;
            }
            this.micSelect.data.model = this.selectedDeviceId;
          }, 100);
          this.micSelect.data.items = this.microphoneOptions;
          this.micSelect.data.model = this.selectedDeviceId;
        })
        .catch(() => {});
    },
    switchMicrophone(deviceId) {
      if (!this.isPublishing || !deviceId || !this.whipPublisher || typeof this.whipPublisher.replaceTrack !== 'function') return;
      this.switchingMic = true;
      this.statusMessage = 'Đang đổi microphone...';
      this.statusClass = 'text-info';

      const constraints = { audio: { deviceId: { exact: deviceId } }, video: false };
      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          if (this.audioCtx) {
            this.audioCtx.close().catch(() => {});
            this.audioCtx = null;
            this.gainNode = null;
          }
          if (this.localStream) {
            this.localStream.getTracks().forEach((t) => t.stop());
          }
          this.stopVolumeMeter();

          this.localStream = stream;
          this.currentPublishDeviceId = deviceId;
          const streamToSend = this.createStreamWithVolume(stream);
          this.publishStream = streamToSend;
          const newTrack = streamToSend.getAudioTracks()[0];
          if (!newTrack) {
            stream.getTracks().forEach((t) => t.stop());
            this.switchingMic = false;
            this.statusMessage = 'Không có âm thanh từ thiết bị.';
            this.statusClass = 'text-danger';
            return;
          }

          this.whipPublisher.replaceTrack(newTrack)
            .then(() => {
              this.startVolumeMeter(stream);
              this.switchingMic = false;
              this.statusMessage = 'Đã đổi microphone.';
              this.statusClass = 'text-success';
            })
            .catch((err) => {
              stream.getTracks().forEach((t) => t.stop());
              this.switchingMic = false;
              this.statusMessage = this.normalizeStatusError(err);
              this.statusClass = 'text-danger';
            });
        })
        .catch((err) => {
          this.switchingMic = false;
          this.statusMessage = this.normalizeStatusError(err);
          this.statusClass = 'text-danger';
        });
    },
    startPublish() {
      if (this.isConnecting || this.isPublishing) return;
      if (this.actionData.model.listDeviceSelectedCode.length === 0) {
        this.statusMessage = 'Chưa có thiết bị nào được chọn.';
        this.statusClass = 'text-danger';
        return;
      }
      // Kiểm tra microphone ngay sau khi đã chọn thiết bị
      if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
        this.statusMessage = 'Trình duyệt không hỗ trợ truy cập microphone.';
        this.statusClass = 'text-danger';
        return;
      }
      const proceedToCheckSchedule = () => {
        this.isClickLivestream = true;
        this.checkExitsScheduleEmergencyPlaying();
      };
      if (typeof navigator.mediaDevices.enumerateDevices !== 'function') {
        proceedToCheckSchedule();
        return;
      }
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          const mics = devices.filter((d) => d.kind === 'audioinput');
          if (!mics.length) {
            this.statusMessage = 'Không tìm thấy microphone nào. Vui lòng kết nối microphone và thử lại.';
            this.statusClass = 'text-danger';
            return;
          }
          proceedToCheckSchedule();
        })
        .catch(() => proceedToCheckSchedule());
    },
    startPublishCore() {
      if (this.isConnecting || this.isPublishing) return;
      const fromSelect = this.micSelect.data.model !== undefined && this.micSelect.data.model !== null && this.micSelect.data.model !== '' ? String(this.micSelect.data.model) : '';
      if (fromSelect && fromSelect !== this.selectedDeviceId) this.selectedDeviceId = fromSelect;
      const deviceId = this.selectedDeviceId || fromSelect;
      const constraints = { audio: true, video: false };
      if (deviceId) constraints.audio = { deviceId: { exact: deviceId } };

      this.isConnecting = true;
      this.statusMessage = 'Đang yêu cầu microphone...';
      this.statusClass = 'text-info';

      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          this.loadDevices();
          this.localStream = stream;
          const track = stream.getAudioTracks()[0];
          this.currentPublishDeviceId = deviceId || (track && track.getSettings && track.getSettings().deviceId) || '';
          const streamToSend = this.createStreamWithVolume(stream);
          this.publishStream = streamToSend;
          this.startVolumeMeter(stream);
          this.statusMessage = 'Đang kết nối...';

          // Gửi socket tạo lịch livestream giống LiveStream.vue
          this.getRealIp()
            .then((ip) => {
              this.$sendMessageSocket('/app/schedule_livestream', JSON.stringify({
                mode: 1,
                deviceIds: this.actionData.model.listDeviceSelectedCode,
                scheduleIdExitsEmergencyPlaying: this.confirmOverrideScheduleEmergency.scheduleId,
                ipRequest: ip,
                scheduleIdOverrideLiveStreamPlaying: this.confirmOverrideScheduleEmergency.scheduleIdOverride,
                searchDeviceModel: this.actionData.model.dataSearch,
                selectedAll: this.actionData.model.selectedAll,
                deviceIgnoreIds: this.actionData.model.deviceIgnoreIds
              }));
            })
            .catch(() => {
              this.$sendMessageSocket('/app/schedule_livestream', JSON.stringify({
                mode: 1,
                deviceIds: this.actionData.model.listDeviceSelectedCode,
                scheduleIdExitsEmergencyPlaying: this.confirmOverrideScheduleEmergency.scheduleId,
                scheduleIdOverrideLiveStreamPlaying: this.confirmOverrideScheduleEmergency.scheduleIdOverride,
                searchDeviceModel: this.actionData.model.dataSearch,
                selectedAll: this.actionData.model.selectedAll,
                deviceIgnoreIds: this.actionData.model.deviceIgnoreIds
              }));
            });
        })
        .catch((err) => {
          this.isConnecting = false;
          this.statusMessage = this.normalizeStatusError(err) || 'Không thể truy cập microphone. Vui lòng kiểm tra thiết bị và quyền.';
          this.statusClass = 'text-danger';
        });
    },
    clearPlaybackLinkDelayTimer() {
      if (this.playbackLinkDelayTimer != null) {
        clearTimeout(this.playbackLinkDelayTimer);
        this.playbackLinkDelayTimer = null;
      }
    },
    /** Gửi link phát (RTSP/...) xuống thiết bị. Gọi khi WHIP đã kết nối và luồng đã sẵn sàng (sau trễ ngắn). */
    sendPlaybackLinkToDevices() {
      if (!this.streamName) return;
      this.$sendMessageSocket('/app/livestream', JSON.stringify({
        mode: 1,
        type: 'init',
        scheduleId: this.streamName,
        startTime: this.playbackStartTime
      }));
    },
    startWhipPublish() {
      // Chỉ tạo WHIP khi đã có stream và chưa phát
      if (this.whipPublisher || !this.publishStream || !this.whipUrl) return;
      this.isConnecting = true;
      this.statusMessage = 'Đang kết nối...';
      this.statusClass = 'text-info';

      this.whipPublisher = createWhipPublisher({
        url: this.whipUrl,
        node: (this.whipNode || '').trim() || undefined,
        stream: this.publishStream,
        audioBitrateKbps: 16,
        iceServers: this.peerConnectionConfig && this.peerConnectionConfig.length ? this.peerConnectionConfig : undefined,
        ...getMediaMtxAuth(),
        onError: (err) => {
          this.clearPlaybackLinkDelayTimer();
          this.isConnecting = false;
          this.statusMessage = this.normalizeStatusError(err);
          this.statusClass = 'text-danger';
          // PeerConnection kết nối thất bại: báo backend kết thúc schedule
          if (this.streamName) {
            this.$sendMessageSocket('/app/livestream', JSON.stringify({
              mode: 1,
              type: 'end',
              scheduleId: this.streamName,
              status: 3 // 3: kết nối thất bại
            }));
            this.streamName = '';
          }
          // Xóa reference để lần bấm "Bắt đầu phát" sau tạo publisher mới (tránh return sớm ở startWhipPublish)
          if (this.whipPublisher) {
            this.whipPublisher.close();
            this.whipPublisher = null;
          }
        },
        onConnected: () => {
          this.clearPlaybackLinkDelayTimer();

          // WHIP đã connected, nhưng RTSP trên thiết bị thường cần ~2-3 giây mới play ổn.
          // Trong thời gian chờ này: UI không báo LIVE/Đang phát và mute audio (gain=0)
          // để luồng không "đổ" ra thiết bị sớm.
          this.isConnecting = true;
          this.isPublishing = false;
          this.isMuted = true;
          if (this.gainNode) this.gainNode.gain.value = 0;
          // Khi RTSP đã sẵn sàng: gửi lệnh play xuống thiết bị.
          this.sendPlaybackLinkToDevices();

          const scheduleIdWhenReady = this.streamName;
          this.playbackLinkDelayTimer = setTimeout(() => {
            this.playbackLinkDelayTimer = null;
            if (!this.streamName || this.streamName !== scheduleIdWhenReady || !this.whipPublisher) return;
            // Unmute để thiết bị bắt đầu nhận audio từ đúng thời điểm.
            if (this.gainNode) {
              this.isMuted = false;
              this.gainNode.gain.value = this.volume / 100;
            }

            this.isConnecting = false;
            this.isPublishing = true;
            this.statusMessage = 'Đã kết nối. Đang phát âm thanh trên thiết bị.';
            this.statusClass = 'text-success';
            this.startRecording();
          }, PLAYBACK_LINK_READY_DELAY_MS);
        }
      });
    },
    stopPublish() {
      this.clearPlaybackLinkDelayTimer();
      this.stopLivestreamHeartbeat();
      // Gửi 'end' ngay đầu dừng phát — F5/đóng tab thường không kịp chạy MediaRecorder.onstop.
      if (this.isPublishing && this.streamName && typeof this.$sendMessageSocket === 'function') {
        try {
          const scheduleId = this.streamName;
          this.$sendMessageSocket('/app/livestream', JSON.stringify({
            mode: 1,
            type: 'end',
            scheduleId
          }));
        } catch (_) {}
      }
      this.stopRecording();
      this.isConnecting = false;
      if (this.whipPublisher) {
        this.whipPublisher.close();
        this.whipPublisher = null;
      }
      this.currentPublishDeviceId = null;
      if (this.audioCtx) {
        this.audioCtx.close().catch(() => {});
        this.audioCtx = null;
        this.gainNode = null;
      }
      this.publishStream = null;
      if (this.localStream) {
        this.localStream.getTracks().forEach((t) => t.stop());
        this.localStream = null;
      }
      this.stopVolumeMeter();
      this.isPublishing = false;
      this.isMuted = false;
      this.statusMessage = 'Đã dừng phát.';
      this.statusClass = 'text-muted';
    },
    startRecording() {
      const streamToRecord = this.publishStream || this.localStream;
      if (!streamToRecord || this.mediaRecorder) return;
      const mimeType = MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
        ? 'audio/webm;codecs=opus'
        : MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4';
      this.recordedChunks = [];
      try {
        const recorder = new MediaRecorder(streamToRecord, { mimeType, audioBitsPerSecond: 128000 });
        recorder.ondataavailable = (e) => {
          if (e.data && e.data.size > 0) this.recordedChunks.push(e.data);
        };
        recorder.onstop = () => {
          if (this.recordedChunks.length === 0) return;
          if (this.recordedBlobUrl) URL.revokeObjectURL(this.recordedBlobUrl);
          const blob = new Blob(this.recordedChunks, { type: mimeType });
          this.recordedBlobUrl = URL.createObjectURL(blob);
          const file = new File(this.recordedChunks, `livestream_${this.streamName}.webm`, {
            type: blob.type,
            lastModified: Date.now()
          });
          // Upload bản ghi (socket 'end' đã gửi ở đầu stopPublish để F5/đóng tab vẫn kết thúc lịch kịp)
          if (this.streamName) {
            const scheduleId = this.streamName;
            this.submitRecordWithFile(scheduleId, file);
            this.streamName = '';
          }
          this.recordedChunks = [];
          const estimatedSec = (blob.size * 8) / 128000;
          if (estimatedSec > 0 && estimatedSec < 86400) {
            this.playbackDuration = Math.max(1, estimatedSec);
          }
        };
        recorder.start(1000);
        this.mediaRecorder = recorder;
      } catch (_) {}
    },
    stopRecording() {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop();
        this.mediaRecorder = null;
      }
    },
    submitRecordWithFile(_scheduleId, file) {
      setTimeout(() => {
        startBackgroundLivestreamRecordUpload({ file, scheduleId: _scheduleId });
      }, 0);
    },
    clearRecordedPlayback() {
      if (this.recordedBlobUrl) {
        URL.revokeObjectURL(this.recordedBlobUrl);
        this.recordedBlobUrl = null;
      }
      this.playbackDuration = 0;
      this.playbackCurrent = 0;
      this.isPlaybackPlaying = false;
    },
    onPlaybackLoaded() {
      const audio = this.$refs.playbackAudio;
      if (!audio) return;
      const d = Number(audio.duration);
      if (Number.isFinite(d) && d > 0) {
        if (!this.playbackDuration || this.playbackCurrent <= 0) {
          this.playbackDuration = d;
        }
      }
      if (!this.playbackDuration) this.playbackCurrent = 0;
    },
    onPlaybackTimeUpdate() {
      const audio = this.$refs.playbackAudio;
      if (!audio) return;
      const t = Number(audio.currentTime);
      this.playbackCurrent = Number.isFinite(t) && t >= 0 ? t : 0;
      const d = Number(audio.duration);
      const curMax = Math.max(this.playbackDuration || 0, this.playbackCurrent);
      if (Number.isFinite(d) && d > 0) {
        if (!this.playbackDuration || (d <= curMax)) {
          this.playbackDuration = d;
        }
      } else if (t > 0 && (!this.playbackDuration || t >= this.playbackDuration - 1)) {
        this.playbackDuration = Math.max(this.playbackDuration || 0, t + 1);
      }
    },
    onPlaybackEnded() {
      const lastTime = this.playbackCurrent;
      this.isPlaybackPlaying = false;
      this.playbackCurrent = 0;
      if (lastTime > 0 && (!this.playbackDuration || lastTime > this.playbackDuration)) {
        this.playbackDuration = lastTime;
      }
    },
    togglePlayback() {
      const audio = this.$refs.playbackAudio;
      if (!audio) return;
      if (this.isPlaybackPlaying) {
        audio.pause();
        this.isPlaybackPlaying = false;
      } else {
        audio.play().then(() => {
          this.isPlaybackPlaying = true;
        }).catch(() => {});
      }
    },
    onSeekPlayback(e) {
      const audio = this.$refs.playbackAudio;
      if (!audio) return;
      const val = parseFloat(e.target.value);
      if (!Number.isFinite(val) || val < 0) return;
      this.playbackCurrent = val;
      audio.currentTime = val;
    },
    formatTime(sec) {
      const total = Number(sec);
      if (!Number.isFinite(total) || total < 0) return '--:--';
      const s = Math.floor(total);
      const m = Math.floor(s / 60);
      const r = s % 60;
      return `${m.toString().padStart(2, '0')}:${r.toString().padStart(2, '0')}`;
    },
    toggleMute() {
      if (!this.isPublishing || !this.gainNode) return;
      this.isMuted = !this.isMuted;
      this.gainNode.gain.value = this.isMuted ? 0 : this.volume / 100;
    },
    createStreamWithVolume(stream) {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const ctx = new AudioContext();
        this.audioCtx = ctx;
        const src = ctx.createMediaStreamSource(stream);
        const gainNode = ctx.createGain();
        gainNode.gain.value = this.isMuted ? 0 : this.volume / 100;
        this.gainNode = gainNode;
        const dest = ctx.createMediaStreamDestination();
        src.connect(gainNode);
        gainNode.connect(dest);
        return dest.stream;
      } catch (_) {
        return stream;
      }
    },
    startVolumeMeter(stream) {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const ctx = new AudioContext();
        const src = ctx.createMediaStreamSource(stream);
        const analyser = ctx.createAnalyser();
        analyser.fftSize = 256;
        analyser.smoothingTimeConstant = 0.8;
        src.connect(analyser);
        this.analyser = analyser;

        const data = new Uint8Array(analyser.frequencyBinCount);

        const tick = () => {
          if (!this.analyser) return;
          analyser.getByteFrequencyData(data);
          let sum = 0;
          for (let i = 0; i < data.length; i++) sum += data[i];
          this.volumeLevel = Math.min(100, Math.round((sum / data.length) * 2));
          this.animationId = requestAnimationFrame(tick);
        };
        tick();
      } catch (_) {}
    },
    stopVolumeMeter() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      this.analyser = null;
      this.volumeLevel = 0;
    }
  }
};
</script>

<style scoped>
.microphone-webrtc {
  min-height: 100%;
}

/* Modal wrapper - bắt mắt, bo góc, đổ bóng sâu */
.mic-modal >>> .modal-dialog {
  max-width: 560px;
  transform-origin: top center;
  animation: mic-modal-fade-in 220ms ease-out;
}
.mic-modal >>> .modal,
.mic-modal >>> .modal-dialog,
.mic-modal >>> .modal-content,
.mic-modal >>> .modal-body {
  overflow-x: hidden !important;
}
.mic-modal >>> .modal-content {
  border: none;
  border-radius: 24px;
  box-shadow: 0 32px 64px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* Keep microphone select2 dropdown inside modal width to avoid page horizontal scroll */
.mic-modal >>> .mic-select-wrap,
.mic-modal >>> .mic-select-wrap .group-select,
.mic-modal >>> .mic-select-wrap .select2,
.mic-modal >>> .mic-select-wrap .select2-container {
  max-width: 100% !important;
}

.mic-modal >>> .mic-select-wrap .select2-dropdown {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.mic-modal >>> .mic-select-wrap .select2-selection__rendered {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  word-break: normal !important;
}

.mic-modal >>> .mic-select-wrap .select2-results__option {
  white-space: normal !important;
  word-break: break-word;
}

@media (max-width: 575.98px) {
  .mic-modal >>> .modal-dialog {
    max-width: calc(100vw - 1rem);
    margin: 0.5rem auto;
  }
}

/* Modal confirm (trùng lịch / ghi đè) dùng chung layout với mic-modal, chỉ thu nhỏ body */
.mic-modal-confirm >>> .modal-body {
  padding: 1.4rem 1.75rem 1.5rem;
}
.mic-modal-confirm >>> .modal-footer {
  padding: 0 1.75rem 1.25rem;
}
.mic-modal-confirm >>> .btn-primary {
  min-width: 110px;
}
.mic-modal-confirm >>> .modal.overflow-auto.fade.show.d-block {
background: rgba(0, 0, 0, 0.28) !important;
}
.mic-modal >>> .modal-header {
  border: none;
  padding: 0;
  min-height: 0;
}

@keyframes mic-modal-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Header tối giản, không nền — chỉ giữ icon + text */
.mic-modal-header {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  padding: 1.25rem 3rem 0.75rem 1.5rem;
  background: transparent;
}
.mic-modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.mic-modal-header:hover .mic-modal-header-icon {
  transform: scale(1.02);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
}
.mic-modal-header-text {
  flex: 1;
  min-width: 0;
}
.mic-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.2rem;
  letter-spacing: -0.02em;
}
.mic-modal-subtitle {
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  line-height: 1.4;
}
.mic-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s, transform 0.15s, box-shadow 0.15s;
}
.mic-modal-close:hover {
  background: #e2e8f0;
  color: #1e293b;
  transform: scale(1.05);
  box-shadow: 0 3px 8px rgba(148, 163, 184, 0.45);
}
.mic-modal-body {
  padding: 1.5rem 1.75rem 1.75rem;
  background: linear-gradient(180deg, #fafbfd 0%, #f1f5f9 100%);
}
.mic-page--in-modal {
  max-width: 100%;
  margin: 0;
}
.mic-modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.75rem;
  background: #fff;
}
.mic-modal-btn-close {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  color: #475569;
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}
.mic-modal-btn-close:hover {
  background: #f8fafc;
  color: #1e293b;
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.mic-page {
  max-width: 520px;
  margin: 0 auto;
}

.mic-header {
  text-align: center;
  margin-bottom: 2rem;
}

.mic-header-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1rem;
  border-radius: 16px;
  background: linear-gradient(135deg, #321fdb 0%, #1f1496 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  box-shadow: 0 8px 24px rgba(50, 31, 219, 0.35);
}

.mic-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
}

.mic-subtitle {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

.mic-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.8);
  transition: box-shadow 0.25s ease;
}
.mic-card:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
}

.mic-card-header {
  padding: 1.15rem 1.5rem;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mic-card-title {
  font-weight: 700;
  color: #1e293b;
  font-size: 1.05rem;
  letter-spacing: -0.01em;
}

.mic-badge {
  font-size: 0.9rem;
  font-weight: 700;
  padding: 0.45rem 0.9rem;
  border-radius: 10px;
  letter-spacing: 0.04em;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.2);
}

.mic-badge-live {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  border: 1px solid rgba(220, 38, 38, 0.2);
  animation: mic-live-pulse 1.4s ease-in-out infinite;
}

.mic-badge-live .fa-circle {
  font-size: 6px;
  margin-right: 6px;
  vertical-align: middle;
  animation: blink 1s ease-in-out infinite;
}

@keyframes blink {
  50% { opacity: 0.5; }
}

@keyframes mic-live-pulse {
  0% {
    transform: translateY(0) scale(1);
    box-shadow: 0 0 0 0 rgba(248, 113, 113, 0.55);
  }
  70% {
    transform: translateY(-1px) scale(1.03);
    box-shadow: 0 0 0 10px rgba(248, 113, 113, 0);
  }
  100% {
    transform: translateY(0) scale(1);
    box-shadow: 0 0 0 0 rgba(248, 113, 113, 0);
  }
}

.mic-card-body {
  padding: 1.6rem 1.8rem;
  font-size: 0.96rem;
}

.mic-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.mic-field {
  margin-bottom: 1.25rem;
}

.mic-field-full {
  grid-column: 1 / -1;
}

.mic-field label {
  display: block;
  font-weight: 600;
  font-size: 1.15rem;
  color: #334155;
  margin-bottom: 0.4rem;
}

.mic-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.15rem;
}

.mic-label-mic {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0;
  font-size: 2.5rem;
  font-weight: 600;
}
.mic-label-mic .fa-microphone {
  font-size: 1.25em;
  opacity: 0.9;
}

.mic-btn-refresh {
  flex-shrink: 0;
  border-radius: 10px !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  padding: 0.45rem 0.9rem !important;
  transition: transform 0.15s, box-shadow 0.15s !important;
}
.mic-btn-refresh .fa {
  font-size: 1.05em;
  margin-right: 0.35rem;
}
.mic-btn-refresh:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mic-label-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  white-space: nowrap;
}

.mic-hint-inline {
  font-weight: 400;
  color: #94a3b8;
  font-size: 0.8rem;
}

.mic-input {
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.95rem;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.mic-input:hover:not(:disabled) {
  border-color: #cbd5e1;
}

.mic-input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.mic-input:disabled {
  background: #f8fafc;
  color: #64748b;
  box-shadow: none;
}

.mic-hint {
  display: block;
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 0.25rem;
}

.mic-auth-hint {
  font-size: 0.8rem;
  color: #64748b;
  margin: -0.5rem 0 1rem;
  padding: 0.5rem 0;
}

.mic-auth-hint .fa {
  margin-right: 0.35rem;
  color: #22c55e;
}

.mic-select-wrap {
  position: relative;
}

.mic-select {
  width: 100%;
  padding: 0.85rem 2.5rem 0.85rem 1.1rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.97rem;
  background: #fff;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.mic-select:hover:not(:disabled) {
  border-color: #cbd5e1;
}

.mic-select:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.mic-select:disabled {
  background: #f8fafc;
  cursor: not-allowed;
  box-shadow: none;
}

.mic-select-arrow {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
  font-size: 0.7rem;
  transition: color 0.2s;
}
.mic-select-wrap:focus-within .mic-select-arrow {
  color: #6366f1;
}

.mic-list-hint {
  font-size: 0.8rem;
  color: #64748b;
  margin: 0.5rem 0 0;
  line-height: 1.45;
}

.mic-volume-value {
  font-weight: 700;
  color: #6366f1;
  margin-left: 0.25rem;
  font-size: 0.95rem;
}

.mic-slider {
  width: 100%;
  max-width: 100%;
  height: 10px;
  margin-top: 0.5rem;
  -webkit-appearance: none;
  appearance: none;
  background: linear-gradient(90deg, #e2e8f0 0%, #cbd5e1 100%);
  border-radius: 10px;
  outline: none;
}
.mic-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.45);
  transition: transform 0.15s, box-shadow 0.15s;
}
.mic-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.5);
}
.mic-slider::-moz-range-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.45);
}
.mic-slider::-moz-range-track {
  background: linear-gradient(90deg, #e2e8f0 0%, #cbd5e1 100%);
  height: 10px;
  border-radius: 10px;
}

.mic-status {
  padding: 0.85rem 1.1rem;
  border-radius: 12px;
  margin-bottom: 0.35rem;
  font-size: 0.9rem;
  min-height: 0;
  border: 1px solid transparent;
}

.mic-status.text-success {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  color: #065f46;
  border-color: rgba(16, 185, 129, 0.2);
}

.mic-status.text-danger {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #b91c1c;
  border-color: rgba(239, 68, 68, 0.2);
}

.mic-status.text-info,
.mic-status.text-muted {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #475569;
  border-color: #e2e8f0;
}

.mic-status .fa {
  margin-right: 0.5rem;
}

.mic-status-header {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
}
.mic-badge-live--inline {
  margin-left: auto;
  flex-shrink: 0;
}

.mic-btn-mute {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  border-radius: 10px;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  background: #fff;
  color: #475569;
  border: 1px solid #e2e8f0;
}
.mic-btn-mute:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #1e293b;
}
.mic-btn-mute--active {
  background: #fef2f2;
  border-color: #f87171;
  color: #dc2626;
}
.mic-btn-mute--active:hover {
  background: #fee2e2;
  border-color: #ef4444;
  color: #b91c1c;
}
.mic-btn-mute--compact {
  padding: 0.35rem 0.6rem;
  font-size: 0.8rem;
}

.mic-vu {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.mic-vu-track {
  flex: 1;
  max-width: 200px;
  height: 10px;
  background: linear-gradient(90deg, #e2e8f0 0%, #cbd5e1 100%);
  border-radius: 10px;
  overflow: hidden;
}

.mic-vu-fill {
  height: 100%;
  background: linear-gradient(90deg, #10b981 0%, #34d399 50%, #fbbf24 100%);
  border-radius: 10px;
  transition: width 0.08s ease;
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.3);
}

.mic-vu-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
}

/* Nút hành động nổi bật */
.mic-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.75rem;
  justify-content: center;
}

.mic-btn {
  padding: 0.85rem 1.75rem;
  border-radius: 14px;
  font-weight: 700;
  font-size: 0.95rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s;
  letter-spacing: 0.02em;
  min-width: 160px;
  justify-content: center;
}

.mic-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
}

.mic-btn:not(:disabled):hover {
  transform: translateY(-2px);
  filter: brightness(1.05);
}

.mic-btn-start {
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.4);
}
.mic-btn-start:not(:disabled):hover {
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.45);
}

.mic-btn-stop {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 50%, #b91c1c 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.35);
}
.mic-btn-stop:not(:disabled):hover {
  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.4);
}

.mic-playback {
  margin-top: 1.25rem;
  padding: 1rem 1.1rem 0.95rem;
  background: radial-gradient(circle at top left, #eef2ff 0, #f8fafc 45%, #f1f5f9 100%);
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
}
.mic-playback-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.mic-playback-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #334155;
}
.mic-playback-title .fa {
  margin-right: 0.4rem;
  color: #6366f1;
}
.mic-playback-clear {
  padding: 0.25rem 0.5rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.mic-playback-clear:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.mic-playback-audio {
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.mic-playback-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
}
.mic-playback-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s, box-shadow 0.15s;
}
.mic-playback-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}
.mic-playback-btn .fa-play { margin-left: 2px; }
.mic-playback-timeline {
  flex: 1;
  min-width: 0;
  margin-top: 0;
}
.mic-playback-range {
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, #dbeafe 0%, #e5e7eb 45%, #e5e7eb 100%);
  outline: none;
}
.mic-playback-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  box-shadow: 0 2px 6px rgba(79, 70, 229, 0.5);
  cursor: pointer;
}
.mic-playback-range::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  cursor: pointer;
}
.mic-playback-range::-moz-range-track {
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, #dbeafe 0%, #e5e7eb 45%, #e5e7eb 100%);
}
.mic-playback-time {
  margin-top: 0.35rem;
  font-size: 0.78rem;
  font-variant-numeric: tabular-nums;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-align: right;
  float: right;
}
.mic-playback-time-current {
  min-width: 3ch;
  text-align: left;
}
.mic-playback-time-sep {
  color: #94a3b8;
  margin: 0 0.15rem;
}
.mic-playback-time-total {
  min-width: 3ch;
  text-align: right;
  font-weight: 600;
  color: #4b5563;
}
</style>
